import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Constructora } from '../../../models/constructora.model';
import { MatDialog } from '@angular/material';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-constructora",
    templateUrl: "./constructora.component.html",
    styleUrls: ["./constructora.component.css"],
    providers: [UserService, FormService]
})

export class ConstructoraComponent {
    @ViewChild('confirmarReemplazo') confirmarReemplazoTemplate: TemplateRef<any>;
    @ViewChild('openModal') openModal: TemplateRef<any>;

    public isNatural
    public rut_consta;
    public invalidRut: Boolean;
    public constructora: Constructora;
    public rows = [];
    public actualRow;
    public mail_const
    public filteredOptions;
    public nombreComuna = new FormControl('', [Validators.required]);
    options = []
    public selectedConstuctora: number = null;
    regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    public matcher = new FormService();
    constructor(private fb: FormBuilder, private _userService: UserService,
        private rutValidator: RutValidator, private dialog: MatDialog, private spinner: NgxSpinnerService) {
        this.rut_consta = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        })

        this.mail_const = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        })
        if (!JSON.parse(localStorage.getItem("constructora"))) {
            localStorage.setItem("constructora", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("constructora"));
        }
        this.invalidRut = true;
        this.constructora = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
    }


    ngOnInit() {

    }

    ngAfterContentInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
    }


    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }

    get_Constructora(rut) {
        this.spinner.show();



        this.cleanData();
        this._userService.getConstructora(rut).subscribe(
            response => {
                if (response.message) {
                    this.constructora.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                } else {
                    this.constructora.rut = response.rut ? response.rut : '';
                    this.constructora.nombre = response.nombre ? response.nombre : '';
                    this.constructora.direccion = response.direccion ? response.direccion : '';
                    this.constructora.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.constructora.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.constructora.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.constructora.comuna = response.comuna ? response.comuna : '';
                    this.constructora.fono = response.fono ? response.fono : '';
                    this.constructora.fax = response.fax ? response.fax : '';
                    this.constructora.mail = response.mail ? response.mail : '';
                    this.constructora.patente = response.patente ? response.patente : '';
                    this.constructora.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);

                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }




    cleanData() {
        this.constructora = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
        this.rut_consta.reset()
    }

    update_constructora(rut, id) {
        this.get_Constructora(rut);
        this.selectedConstuctora = id;
    }


    saveConstructora() {
        this.spinner.show();

        //elimina la fila si escriben un rut que ya esté ingresado        
        for (let x = 0; x < this.rows.length; x++) {
            if (this.constructora.rut == this.rows[x].rut) {
                this.delete_Constructora(x);
            }
        }

        //elimina fila cuando la editan
        /*if (this.selectedConstuctora != null) {
            this.delete_Constructora(this.selectedConstuctora);
            this.selectedConstuctora = null;
        }*/

        this._userService.saveConstructora(this.constructora).subscribe(
            response => {
                this.spinner.hide();

                if (response.update || response.save) {
                    $("#const_modal").modal("hide");
                    const stored = localStorage.getItem("constructora");
                    this.rows = stored ? JSON.parse(stored) : [];

                    if (this.rows.length > 0) {
                        this.dialog.closeAll()
                        this.newPropietario()
                       /*  const dialogRef = this.dialog.open(this.confirmarReemplazoTemplate, {
                            width: '400px',
                            disableClose: true,
                            data: {}
                        });

                        dialogRef.afterClosed().subscribe(result => {
                            if (result === true) {
                                console.log("se quiere reemplazar");
                            }
                        }); */
                    } else {
                        this.newPropietario()
                    }

                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }

    newPropietario() {
         this.rows = this.rows.concat({
            rut: this.constructora.rut,
            nombre: this.constructora.nombre,
            direccion: this.constructora.direccion,
            direccion_num: this.constructora.direccion_num,
            direccion_complemento: this.constructora.direccion_complemento,
            direccion_completa: this.constructora.direccion_completa,
            comuna: this.constructora.comuna,
            fono: this.constructora.fono,
            fax: this.constructora.fax,
            patente: this.constructora.patente,
            mail: this.constructora.mail,
        });

        // Resetear campos y cerrar el diálogo
        localStorage.setItem("constructora", JSON.stringify(this.rows));
        this.constructora = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
        this.rut_consta.reset()
        this.dialog.closeAll();
    }

    delete_Constructora(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("constructora", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('constructora'));
            }
        }
    }

    getComunas() {

        if (JSON.parse(localStorage.getItem("comunas"))) {
            if (JSON.parse(localStorage.getItem("comunas")).length > 0) {
                this.options = JSON.parse(localStorage.getItem('comunas'));

            } else {
                this.options = []
            }
        }

        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );

    }
}